export const fetchToken = ({
  client_id,
  code,
  state,
  grant_type,
  tokenEndpoint,
  fetch = window.fetch,
}) => {
  const payload = {
    client_id,
    code,
    grant_type,
    // code_verifier: state.encodedVerifier,
    redirect_uri: state.redirect_uri,
    // challenge_method: 'sha256'
  };

  return fetch(tokenEndpoint, {
    body: new window.URLSearchParams(payload),

    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    method: "POST",
  })
    .then((r) => {
      if (!r.ok) {
        throw new Error(`Failed to retrieve token.`);
      }
      return r.json();
    })
    .then((token) => {
      const { expires_in } = token;
      if (expires_in && Number.isFinite(expires_in)) {
        const slackSeconds = 10;
        token.expires_at = new Date(
          new Date().getTime() + expires_in * 1000 - slackSeconds * 1000
        );
      }
      return token;
    })
    .catch((err) => {
      console.error("ERR (fetch)", err);
      throw err;
    });
};
